import { useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import { MdPublishedWithChanges } from "react-icons/md";
import Swal from "sweetalert2";
import { userServices } from "../../../../APIServices/UserData/userServices";

const RegenerateSecretKey = ({
  auth, 
  Show,
  Hide,
  Title,
  isDark,
}) => {
  const [password, setPassword] = useState("");
  const [loader, setLoader] = useState("");

  const regenerateSecretKey = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Re-generate Secret key?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Re-generate it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        let userData = {};
        userData.password = password;
        let data = await userServices.regenerateSecretKey(auth, userData);
        if (data?.statusCode === 200) {
          setPassword("");
          Hide();
        }
        setLoader(false);
      }
    });
  };
  return (
    <Modal show={Show} onHide={Hide} size="md">
      <Modal.Header
        closeButton
        className={`${isDark ? "bg-dark text-light" : "bg-light"} p-3 border-bottom`}
      >
        <Modal.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={`rounded-bottom ${isDark ? "bg-dark" : "bg-white"}`}>
        <Form.Group className="mb-2">
          <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
            Password
          </Form.Label>
          <Form.Control
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="Enter Password"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <div className="hstack justify-content-end">
          <Button
            disabled={!password || loader}
            variant="outline-primary"
            style={{ fontSize: 13 }}
            onClick={regenerateSecretKey}
            title="Re-generate Secret Key"
            className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
          >
            <MdPublishedWithChanges /> Re-generate
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default RegenerateSecretKey;
